export const checkPhoneNumber = 'PhoneNumber';
export const checkRePassword = 'checkRePassword';
export const checkEmail = 'Email';
export const checkPassword = 'Password';
export const checkNumber = 'Number';